import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '../services/error-handler.service';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  showNoError: any;

  constructor(public errorHandlerService: ErrorHandlerService) {
    this.showNoError = [
      '/agencias/login/',
      '/agencias/validarip/',
      '/agencias/envioemailvalidacionip/',
      '/agencias/validaremail/',
      '/agencias/envioemailvalidacion/',
      '/agencias/confirmarcambioemail/',
      '/agencias/solicitarcambioemail/',
    ];
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        const silenced = this.showNoError.some((u: string) => request.url.indexOf(u) >= 0);
        // La validación de IP la resuelve el modal del propio flujo, no el diálogo global.
        const validatesIp = error.error && error.error.Codigo === AuthService.ipValidationCode;
        if (!silenced && !validatesIp) {
          this.errorHandlerService.openDialog(error);
        }
        return throwError(error);
      }),
    );
  }
}
